/**
 * Card types
 */
export const CARD_GIFT = 'gift';
export const CARD_INSTAGRAM = 'instagram';

export const PUSHER_API = 'bf8aa91008c01d4fc5c0';

export const API_URL = process.env.NODE_ENV === 'production' ? 'https://www.wallofgiving.com.au/api' : 'http://www.wallofgiving.dev.au/api';



// WEBPACK FOOTER //
// ./src/constants.js